/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FeedbackModal, Modal,
} from '@cgn/framework-ui-components/v2';
import { Stepper, Snackbar } from '@cgn/framework-ui-components/v1';
import SceltaServizio from './stepSceltaServizio/SceltaServizio';
import InformazioniAggiuntive from './stepInformazioniAggiuntive/InformazioniAggiuntive';
import CompilaQuestionario from './stepCompilaQuestionario/CompilaQuestionario';
import {
  ERRORE_INVIO_QUESITO, MessagioGestioneInTempoDefinito, MessagioGestioneInTempoNonDefinito, MessagioErroreInvioQuesito,
} from '../Shared/messages';
import { existsSetInformazioniAggiuntive } from './categoria';
import useNuovoQuestitoSteps, { stepSceltaServizio } from './useNuovoQuestitoSteps';
import { creaPratica } from '../Api/nuovaPratica';
import NuovoQuestitoTitle from './NuovoQuestitoTitle';
import useUtente from '../Shared/Profilo/useUtente';
import { sanitize } from '../utils/dom/utils';
import FooterModaleNuovoQuestito from './FooterModaleNuovoQuestito';

/**
 * Modale per l'inserimento di un nuovo quesito.
*/
const ModaleNuovoQuesito = ({
  show, baseUrl, ufficioSelezionato, areaSelezionata, onClose,
  idMessaggio, origine,
  selezioneBloccata, categoria: categoriaBloccata, servizio: servizioBloccato,
  oggetto: oggettoBloccato, messaggio: messaggioBloccato,
  onCloseFeedbackConfermaInvio, onOpenFeedbackConfermaInvio, initialPos,
}) => {
  const utente = useUtente();

  // gestione feedback
  const [feedbackNuovoQuestitoCreato, setFeedbackNuovoQuestitoCreato] = useState();
  const [quesitoCreatoConSuccesso, setQuesitoCreatoConSuccesso] = useState();

  // stato
  const [servizio, setServizio] = useState();
  const [categoria, setCategoria] = useState();

  const [argomento, setArgomento] = useState();
  const [campoAux1, setCampoAux1] = useState();
  const [campoAux2, setCampoAux2] = useState();

  const [oggetto, setOggetto] = useState(oggettoBloccato || '');
  const [messaggio, setMessaggio] = useState(messaggioBloccato || '');
  const [allegati, setAllegati] = useState([]);
  const [uploadingAllegato, setUploadingAllegato] = useState(false);

  // gestione workflow

  const [
    currentStep,
    setCurrentStep,
    steps,
    stati,
  ] = useNuovoQuestitoSteps(categoria);

  const handleOnClose = (closeFeedback = false) => {
    setServizio();
    setCategoria();
    setArgomento();
    setCampoAux1();
    setCampoAux2();
    setOggetto('');
    setMessaggio('');
    setAllegati([]);
    setCurrentStep(steps[0]);
    setFeedbackNuovoQuestitoCreato();
    setQuesitoCreatoConSuccesso();
    closeFeedback ? onCloseFeedbackConfermaInvio() : onClose();
  };

  const handleNextOnClick = () => {
    const handleError = (error) => {
      Snackbar.show({ type: Snackbar.Types.ERROR, message: error.DetectedProblems || ERRORE_INVIO_QUESITO });
      handleOnClose();
    };

    if (currentStep !== steps[steps.length - 1]) {
      setCurrentStep(steps[steps.indexOf(currentStep) + 1]);
      return undefined;
    }
    return creaPratica(baseUrl, {
      servizio,
      categoria,
      argomento,
      oggetto: sanitize(oggetto),
      messaggio: sanitize(messaggio),
      allegati,
      campoAux1,
      campoAux2,
      profilo: utente,
      idMessaggio,
      origine,
      ufficioSelezionato,
    })
      .then((res) => {
        if (!res.Success) {
          setQuesitoCreatoConSuccesso(false);
          setFeedbackNuovoQuestitoCreato(<MessagioErroreInvioQuesito />);
        } else {
          setQuesitoCreatoConSuccesso(true);
          if (!res.TempoAttesaStimato) {
            setFeedbackNuovoQuestitoCreato(<MessagioGestioneInTempoNonDefinito />);
          } else {
            setFeedbackNuovoQuestitoCreato(<MessagioGestioneInTempoDefinito tempoAttesaStimato={res.TempoAttesaStimato} />);
          }

          onOpenFeedbackConfermaInvio();
        }
      })
      .catch(handleError);
  };

  // diffModalContentModalBody={24} patch per gestire modale e dimensioni piccole dello schermo
  return (
    <>
      <Modal
        show={show && !feedbackNuovoQuestitoCreato}
        contentClassName="helpdesk-frontend-modale"
        onClose={handleOnClose}
        initialPos={initialPos}
        diffModalContentModalBody={24}
      >
        <Modal.Header>
          <NuovoQuestitoTitle
            avvisaScadenza={currentStep === stepSceltaServizio}
            codiceUfficio={ufficioSelezionato}
          />
        </Modal.Header>
        <Modal.Body>
          <Stepper className="">
            <Stepper.Step state={stati[0] /* stepSceltaServizio */} title="Scelta servizio">
              <SceltaServizio
                baseUrl={baseUrl}
                areaSelezionata={areaSelezionata}
                ufficioSelezionato={ufficioSelezionato}
                selezioneBloccata={selezioneBloccata}
                categoriaBloccata={categoriaBloccata}
                servizioBloccato={servizioBloccato}
                servizio={servizio}
                onChangeServizio={(newServizio) => {
                  setCategoria(undefined);
                  setArgomento(undefined);
                  setServizio(newServizio);
                }}
                categoria={categoria}
                onChangeCategoria={(newCategoria, newCategoriaDisablitata) => {
                  setArgomento(undefined);
                  setCategoria(newCategoria);
                }}
              />
            </Stepper.Step>
            {
              existsSetInformazioniAggiuntive(categoria)
              && (
                <Stepper.Step state={stati[1] /* stepInformazioniAggiuntive */} title="Informazioni aggiuntive">
                  <InformazioniAggiuntive
                    argomenti={categoria.argomenti}
                    ufficioSelezionato={ufficioSelezionato}
                    etichettaCampoAux1={categoria.EtichettaCampoAux1}
                    etichettaCampoAux2={categoria.EtichettaCampoAux2}
                    argomento={argomento}
                    onChangeArgomento={setArgomento}
                    campoAux1={campoAux1}
                    onChangeCampoAux1={setCampoAux1}
                    campoAux2={campoAux2}
                    onChangeCampoAux2={setCampoAux2}
                  />
                </Stepper.Step>
              )
            }
            <Stepper.Step state={stati[2] /* stepCompilaQuesito */} title="Compila quesito">
              <CompilaQuestionario
                ufficioSelezionato={ufficioSelezionato}
                codiceArea={servizio && servizio.Alias}
                fileUploadHelper={(argomento || categoria || {}).HelpAllegati}
                oggetto={oggetto}
                onChangeOggetto={setOggetto}
                messaggio={messaggio}
                onChangeMessaggio={setMessaggio}
                allegati={allegati}
                onChangeAllegati={setAllegati}
                onUploadingAllegatoChange={setUploadingAllegato}
              />
            </Stepper.Step>
          </Stepper>
        </Modal.Body>
        <Modal.Footer>
          <FooterModaleNuovoQuestito
            currentStep={currentStep}
            codiceUfficio={ufficioSelezionato}
            onIndietroClick={() => setCurrentStep(steps[steps.indexOf(currentStep) - 1])}
            onAvantiClick={handleNextOnClick}
            servizio={servizio}
            categoria={categoria}
            argomento={argomento}
            oggetto={uploadingAllegato ? undefined : oggetto} // oggetto vuoto per disabiltiare avanzamento
            messaggio={messaggio}
          />
        </Modal.Footer>
      </Modal>
      <FeedbackModal
        show={show && feedbackNuovoQuestitoCreato}
        onClose={() => { handleOnClose(true); }}
        type={quesitoCreatoConSuccesso ? 'success' : 'alarm'}
        title={quesitoCreatoConSuccesso ? 'Quesito inviato con successo' : "Errore nell'invio del quesito"}
        message={feedbackNuovoQuestitoCreato || ''}
      />
    </>
  );
};

ModaleNuovoQuesito.propTypes = {
  show: PropTypes.bool,
  baseUrl: PropTypes.string,
  ufficioSelezionato: PropTypes.string,
  areaSelezionata: PropTypes.string,
  onClose: PropTypes.func,
  idMessaggio: PropTypes.string,
  onOpenFeedbackConfermaInvio: PropTypes.func,
  onCloseFeedbackConfermaInvio: PropTypes.func,
  /**
   * Origine della creazione della pratica.
  */
  origine: PropTypes.string.isRequired,
  selezioneBloccata: PropTypes.bool,
  categoria: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  servizio: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  oggetto: PropTypes.string,
  messaggio: PropTypes.string,
  /** Indica la posizione iniziale di apertura della modale */
  initialPos: PropTypes.shape({
    x: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    y: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

ModaleNuovoQuesito.defaultProps = {
  baseUrl: '',
  show: false,
  ufficioSelezionato: undefined,
  idMessaggio: undefined,
  areaSelezionata: undefined,
  onClose: undefined,
  onOpenFeedbackConfermaInvio: undefined,
  onCloseFeedbackConfermaInvio: undefined,
  selezioneBloccata: undefined,
  categoria: undefined,
  servizio: undefined,
  oggetto: undefined,
  messaggio: undefined,
  initialPos: undefined,
};

export default ModaleNuovoQuesito;
